import React from 'react';
import { Link } from 'react-router-dom';
import { HiHome } from 'react-icons/hi';

const NotFound = () => {
    return (
        <div className="w-full h-screen bg-[#0b1120] text-gray-300 flex flex-col justify-center items-center px-4 text-center">
            <div className="max-w-[600px] w-full flex flex-col items-center">
                <span className="text-8xl sm:text-9xl font-extrabold text-[#15434e] tracking-widest">
                    404
                </span>
                <h1 className="text-3xl sm:text-5xl font-bold text-gray-100 mt-4 mb-2">
                    Page Not Found
                </h1>
                <p className="text-gray-400 text-lg sm:text-xl mb-8">
                    Oops! The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
                </p>
                <Link
                    to="/"
                    className="inline-flex items-center px-6 py-3 border-2 border-[#15434e] bg-[#15434e] text-white font-semibold rounded hover:bg-transparent hover:border-[#64ffda] hover:text-[#64ffda] transition-all duration-300 group shadow-lg"
                >
                    <HiHome className="mr-2 text-xl" /> Return to Homepage
                </Link>
            </div>
        </div>
    );
};

export default NotFound;
